import { IconProps } from "./iconTypes";

export function StopIcon(props: IconProps) {
  return (
    <svg
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      style={{ display: "inline-block", verticalAlign: "middle" }}
      {...props}
    >
      <rect x='4' y='4' width='12' height='12' fill='currentColor' />
    </svg>
  );
}
